module.exports = __webpack_public_path__ + "static/media/dark_logo.e18ae5f5.png";